// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// 3. AXIOS 설정, API서버 주소 셋팅
// axios.defaults.baseURL = 'http://10.94.1.127:9000';
// axios.defaults.baseURL = 'http://10.94.1.127:8081/reachwise-backend';
// axios.defaults.baseURL = 'http://121.78.124.116/reachwise-backend';
axios.defaults.baseURL = '/reachwise-backend';
// 121.78.124.114 ~ 115 ~ 116

Vue.prototype.$http = axios;
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    credential :{
      clientName : 'my-trusted-client',
      clientSecret : 'secret',
    },
    accessToken: null,
    server:{
      // API서버 주소 셋팅
      // api_domain : "http://10.94.1.127:9000",
      // api_domain : "http://10.94.1.127:8081/reachwise-backend",
      // api_domain : "http://121.78.124.116/reachwise-backend",
      api_domain : "/reachwise-backend",
    },
    historyStates : true,
  },
  getters: {
    getAPIDomain: function (state) {
      return state.server.api_domain;
    },
    getCredentialCode: function (state){
      return 'Basic ' + btoa(state.credential.clientName +':'+ state.credential.clientSecret)
    },
    getHistoryStates: function (state){
      return state.historyStates;
    }
  },
  setters:{
    setHistoryStates: function (val){
      state.historyStates = val;
    }
  },
  mutations: {
    LOGIN (state, {accessToken}) {

    },
    LOGOUT (state) {
      state.accessToken = null
    }
  },
  actions: {
    LOGIN ({commit}, param) {
      // console.log('actions : ' + param)
      sessionStorage.setItem("myToken", param.access_token);
      // sessionStorage.setItem("dashBoardReload", 'true'); // 임시코드 2018-09-20
      commit('LOGIN', param)
    },
    LOGOUT ({commit}) {
      commit('LOGOUT')
      sessionStorage.setItem("myToken", null);
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js